// Packages
import jwtDecode from 'jwt-decode';
import { getInstance } from './auth/auth0Plugin'

export const getDecodedToken = async () => {
  const authInstance = await getInstance();
  const token = await authInstance.getAccessToken();
  let decodedToken = null;
  if (token) {
    decodedToken = await jwtDecode(token);
  }
  return decodedToken;
};
